import React from 'react'

type PortableTextFontSizeProps = {
  children: React.ReactNode
  size: 14 | 16 | 18 | 24 | 32 | 40 | 48
}

export const PortableTextFontSize = ({
  children,
  size,
}: PortableTextFontSizeProps) => (
  <span
    className={`portable-font-size portable-font-size--${size}`}
    style={{ display: 'inline' }}
  >
    {children}
  </span>
)
